import { Alert, Card } from '@dreamtree-org/twreact-ui';

/** Shown when this hostname is not a verified merchant domain (or the store is unavailable). */
export default function UnknownHost({ error }) {
  const suspended = error && /^COMPANY_/.test(error.code || '');
  return (
    <div className="min-h-dvh flex items-center justify-center p-4 bg-[var(--app-bg)]">
      <Card className="w-full max-w-md p-6 space-y-3">
        <h1 className="text-xl font-bold">{suspended ? 'Store unavailable' : 'Store not found'}</h1>
        <Alert variant={suspended ? 'warning' : 'info'} title={window.location.hostname}>
          {(error && error.error) || 'This address is not connected to a MerchantPro store.'}
        </Alert>
      </Card>
    </div>
  );
}
